import React from 'react'
import { Link } from 'react-router-dom'
import {Form, Button, message, Select} from 'antd';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

import Step2 from './Step2';
import Step3aPatient from './Step3aPatient';
import Step3aRegainedCapacity from './Step3aRegainedCapacity';
import Step3b from './Step3b';
import Step4 from './Step4';
import Signature from "./Signature";

import {consentServices} from "../../services";

const { Option } = Select;

export const ConsentTypes = {
  'Patient_Electronic': 'consent_patient_electronic',
  'Patient_Paper': 'consent_patient_paper',
  'Patient_Email': 'consent_patient_email',
  'Patient_RegainedCapacity': 'consent_patient_electronic_regained_capacity_form',
  'Patient_RegainedCapacityPaper': 'consent_patient_regained_capacity_paper',
  'Patient_EmailRegainedCapacity': 'consent_regained_capacity_form_email',
  'Surrogate_Electronic': 'consent_surrogate_electronic',
  'Surrogate_Paper': 'consent_surrogate_paper',
  'Surrogate_Email': 'consent_surrogate_email',
};

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      currentStepPerson: '',
      currentStep: 'Step 2',
      step: {
        ...this.initialStep,
      },
      currentStepInt: 2,
    }
  }

  initialStep = {};

  componentDidMount() {
    if (this.props.token) {
      this.setState(state => ({ currentStepPerson: this.props.currentStepPerson, currentStep: 'Step 3a', step: { ...state.step, ...this.props.step }}));
    }
  }

  normFile = e => {
    if (Array.isArray(e)) { return e; }
    if (e.fileList.length > 1) { e.fileList.shift(); }
    this.setState(state => ({ step: { ...state.step, fileList: e.fileList }}));

    return e && e.fileList;
  };

  normFileDc = e => {
    if (Array.isArray(e)) { return e; }
    if (e.fileList.length > 1) { e.fileList.shift(); }
    this.setState(state => ({ step: { ...state.step, fileListDc: e.fileList }}));

    return e && e.fileList;
  };

  normFileWithdraw = e => {
    if (Array.isArray(e)) { return e; }
    if (e.fileList.length > 1) { e.fileList.shift(); }
    this.setState(state => ({ step: { ...state.step, fileListWithdraw: e.fileList }}));

    return e && e.fileList;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (values['dateOfBirth']) {
          values['dateOfBirth'] = moment.utc(values['dateOfBirth'], 'YYYY-MM-DD').format('YYYY-MM-DD')
        }

        this.setState(state => ({ step: { ...state.step, ...this.normalizeValues(values) } }), async () => {
          const { currentStep, step: { consentMethodType, consentPersonType }, currentStepPerson } = this.state;

          if (currentStep === 'Step 2') {
            if (['Electronic', 'Email'].includes(consentMethodType) && !currentStepPerson) {
              this.setState(state => ({ currentStepInt: 3, currentStep: 'Step 3a', step: { ...state.step }, currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' }));
            }

            if (['RegainedCapacity', 'WithdrawConsentElectronic', 'EmailRegainedCapacity', 'WithdrawConsentEmail'].includes(consentMethodType)) {
              this.setState(state => ({ currentStepInt: 3, currentStep: 'Step 3a', step: { ...state.step } }));
            }

            if (['Paper', 'WithdrawConsentPaper', 'RegainedCapacityPaper'].includes(consentMethodType)) {
              this.setState(state => ({ currentStepInt: 3, currentStep: 'Step 3b', step: { ...state.step } }));
            }

            return;
          }

          if (currentStep === 'Step 3a' && consentMethodType === 'Electronic' && currentStepPerson === 'Investigator') {
            this.setState(state => ({ currentStepInt: 3, currentStep: 'Step 3a', step: { ...state.step }, currentStepPerson: consentPersonType === 'Surrogate' ? 'Surrogate' : 'Patient' }));
            return;
          }

          if (currentStep === 'Step 3a' && consentMethodType === 'Email' && currentStepPerson === 'Investigator') {
            await this.sendForm(this.normalizeValues(values));
            return;
          }

          if (currentStep === 'Step 3a') {
            await this.sendForm(this.normalizeValues(values));
          }

          if (currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType)) {
            try {
              await this.sendForm(this.normalizeValues(values), values['consentFile']);
            } catch (e) {
              if (e.response) {
                message.error(get(e, 'response.data.error', 'Error'), 5);
              }
            }
          }

          if (currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType)) {
            try {
              await this.sendForm(this.normalizeValues(values), values['consentFile'], values['consentFileDc'], values['consentFileWithdraw']);
            } catch (e) {
              if (e.response) {
                message.error(get(e, 'response.data.error', 'Error'), 5);
              }
            }
          }
        });
      }
    });
  };

  normalizeValues = values => {
    const normalizedValues = { ...values };
    for (const key in values) {
      if (moment.isMoment(values[key])) {
        const date = cloneDeep(values[key]);
        normalizedValues[key] = date.format('YYYY-MM-DDTHH:mm');
        // moment.tz(this.props.userTimezone || get(this.props, 'site.time_zone') || 'UTC').utc(this.props.profile.death_date)
      }
      if (values[key] === 'true') { normalizedValues[key] = true; }
      if (values[key] === 'false') { normalizedValues[key] = false; }
    }

    return normalizedValues;
  };

  sendForm = async (values, file, fileDc = null, fileWithdraw = null) => {
    const { token } = this.props;
    this.setState({ loading: true });

    const propsFormValues = {
      siteID: this.props.step.siteID,
      subjectID: this.props.step.subjectID,
      userID: this.props.step.userID,
    };

    const formData = {
      ...this.state.step,
      ...propsFormValues,
      consent_type: ConsentTypes[`${this.state.step.consentPersonType}_${this.state.step.consentMethodType}`],
      consentMethodType: undefined,
      consentPersonType: undefined,
    };

    try {
      if (token) {
        const {data} = await consentServices.confirmConsentKingstonByToken(token, formData);
        this.setState(state => ({ currentStep: 'Step 4', step: { ...state.step, ...data }}));
      } else {
        const { data } = await consentServices.createKingston(formData, file, fileDc, fileWithdraw);
        this.setState(state => ({ currentStep: 'Step 4', step: { ...state.step, ...data }}));
      }
    } catch (e) {
      console.log(e);
      if (e.response) {
        message.error(get(e, 'response.data.error'), 5);
      }
    }

    this.setState({ loading: false });
  };

  onPrev = () => {
    const { currentStep } = this.state;

    if (currentStep === 'Step 2') {
      this.props.history.push('/consent');
    } else if (['Step 3a', 'Step 3b'].includes(currentStep)) {
      this.setState({ step: { ...this.initialStep }, currentStep: 'Step 2', currentStepPerson: '' });
    }
  };

  render() {
    const { loading, currentStep, step: { consentMethodType, consentPersonType }, step, currentStepPerson } = this.state;
    const { token } = this.props;
    window.form = this.props.form;

    return (
      <div>
        <h2>Consent - {this.state.currentStep}</h2>
        <Form onSubmit={this.handleSubmit} className='main-form'>
          {currentStep === 'Step 2' &&
            <Step2 {...this.props.step} form={this.props.form} {...this.state.step} />}

          {/*{currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && currentStepPerson === 'Investigator' &&
            <div>
              <Step3aInvestigator {...this.props.step} form={this.props.form} {...this.state.step} />

              <Signature fieldName='dc_investigator_signature' dateFieldName='dc_investigator_signature_datetime' label='Signature of investigator/designee' form={this.props.form} />
            </div>}*/}

          {currentStep === 'Step 3a' && ['Electronic', 'Email'].includes(consentMethodType) && ['Patient', 'Surrogate'].includes(currentStepPerson) &&
            <div>
              <Step3aPatient {...this.props.step} form={this.props.form} {...this.state.step} token={token} />
            </div>
          }

          {currentStep === 'Step 3a' && ['RegainedCapacity', 'EmailRegainedCapacity'].includes(consentMethodType) &&
            <div>
              <Step3aRegainedCapacity {...this.props.step} form={this.props.form} {...this.state.step} token={token} />
            </div>
          }

          {currentStep === 'Step 3b' && !['Paper'].includes(consentMethodType) &&
            <Step3b {...this.props.step} form={this.props.form} {...this.state.step} normFile={this.normFile} />}

          {currentStep === 'Step 3b' && ['Paper'].includes(consentMethodType) &&
            <Step3b {...this.props.step} form={this.props.form} {...this.state.step} normFile={this.normFile} normFileDc={this.normFileDc} normFileWithdraw={this.normFileWithdraw} />}

          {currentStep === 'Step 4' &&
            <Step4 {...this.props.step} {...this.state.step} token={token} />}


          {currentStep !== 'Step 4' && <div className='action-wrapper'>
            <Button type='primary' size='large' htmlType="submit" loading={loading}>
              {((currentStep === 'Step 1' || currentStep === 'Step 2') || ['Investigator', 'Patient', 'Surrogate'].includes(currentStepPerson)) ? 'Next' : 'Submit'}
            </Button>
            {(currentStep === 'Step 2' || currentStep === 'Step 3a' || currentStep === 'Step 3b') && !token &&
              <Button type='secondary' size='large' htmlType="button" onClick={this.onPrev}>Back</Button>
            }
          </div>}
        </Form>

        <h5>or select one of the following options:</h5>
        <p>
          <Link to='/'><Button type='primary' size='large'>Home</Button></Link>
        </p>
      </div>
    )
  }
}


const ConsentForm = Form.create()(Consent);

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/ConsentTypeKingston/ConsentForm.js